import {
  Box,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  Text,
  VStack,
} from "@chakra-ui/react";
import { RiSearch2Fill } from "react-icons/ri";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";

const PracticeUsersSearchBar = ({ setSearchTerm }) => {
  return (
    <VStack w="100%" my={{ base: "50px", md: "30px" }}>
      <Flex
        alignItems="center"
        w="100%"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <Text
          fontSize="24px"
          fontWeight="600"
          color="main_1"
          width={{ base: "100%", md: "40%" }}
          mb={{ base: "10px", md: 0 }}
        >
          مستخدمو Asquera Practice
        </Text>

        <Box display={{ base: "none", md: "block" }}>
          <LogoutMenu />
        </Box>
      </Flex>

      <HStack
        w="100%"
        justifyContent="space-between"
        bg="#f5f5f5"
        mt="40px !important"
        p="10px"
        mb="-30px !important"
      >
        <InputGroup w="400px">
          <InputLeftElement
            pointerEvents="none"
            children={<RiSearch2Fill color="main_1" fontSize="20px" />}
          />
          <Input
            type="text"
            placeholder="ابحث باسم المستخدم"
            borderRadius="16px"
            bg="white"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </InputGroup>
      </HStack>
    </VStack>
  );
};

export default PracticeUsersSearchBar;
